(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    const headerEl = document.querySelector('header-section[data-cart-type]');
    const cartType = headerEl ? headerEl.getAttribute('data-cart-type') : undefined;
    if (cartType !== 'page') {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', async (event) => {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart?sections=cart-ajax`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      const sections = await response.json();
      const state = { sections };

      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: {
            product: state,
          },
        })
      );

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            cart: state,
          },
        })
      );
    } catch (e) {
      console.warn('Failed to load cart sections after add:', e);
    }
  });

  document.addEventListener('product-form:message:success', (event) => event.preventDefault());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["riva-cta-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initCtaBanner(root) {
    if (!root || root.dataset.rivaCtabInit === '1') return;
    root.dataset.rivaCtabInit = '1';

    var motionOn = root.dataset.rivaCtabMotion === '1';

    if (!motionOn || reducedMotion() || !('IntersectionObserver' in window)) {
      root.classList.remove('riva-cta-banner--reveal-prepped');
      root.classList.add('riva-cta-banner--inview');
      return;
    }

    root.classList.add('riva-cta-banner--reveal-prepped');

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          root.classList.add('riva-cta-banner--inview');
          io.unobserve(root);
        });
      },
      { root: null, rootMargin: '0px 0px -8% 0px', threshold: [0, 0.08, 0.15] }
    );

    io.observe(root);
  }

  function bootAll() {
    document.querySelectorAll('[data-riva-cta-banner]').forEach(initCtaBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var wrap = ev.target;
    if (!wrap || !wrap.id || wrap.id.indexOf('shopify-section-') !== 0) return;
    var root = wrap.querySelector('[data-riva-cta-banner]');
    if (!root) return;
    root.dataset.rivaCtabInit = '';
    root.classList.remove('riva-cta-banner--reveal-prepped', 'riva-cta-banner--inview');
    initCtaBanner(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["riva-features-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initFeaturesGrid(root) {
    if (!root || root.dataset.rivaFgInit === '1') return;
    root.dataset.rivaFgInit = '1';

    var motionOn = root.dataset.rivaFgMotion === '1';

    if (!motionOn || reducedMotion() || !('IntersectionObserver' in window)) {
      root.classList.remove('riva-features-grid--reveal-prepped');
      root.classList.add('riva-features-grid--inview');
      return;
    }

    root.classList.add('riva-features-grid--reveal-prepped');

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          root.classList.add('riva-features-grid--inview');
          io.unobserve(root);
        });
      },
      { root: null, rootMargin: '0px 0px -8% 0px', threshold: [0, 0.08, 0.15] }
    );

    io.observe(root);
  }

  function bootAll() {
    document.querySelectorAll('[data-riva-features-grid]').forEach(initFeaturesGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var wrap = ev.target;
    if (!wrap || !wrap.id || wrap.id.indexOf('shopify-section-') !== 0) return;
    var root = wrap.querySelector('[data-riva-features-grid]');
    if (!root) return;
    root.dataset.rivaFgInit = '';
    root.classList.remove('riva-features-grid--reveal-prepped', 'riva-features-grid--inview');
    initFeaturesGrid(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["riva-how-it-works"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function revealAll(nodes) {
    nodes.forEach(function (n) {
      n.classList.remove('riva-hiw-prepped');
      n.classList.add('riva-hiw-visible');
    });
  }

  function initHowItWorks(sectionEl) {
    if (!sectionEl || sectionEl.dataset.rivaHiwInit === '1') return;
    sectionEl.dataset.rivaHiwInit = '1';

    var motionOn = sectionEl.dataset.rivaHiwMotion === '1';
    var nodes = sectionEl.querySelectorAll('[data-riva-hiw-animate]');
    if (!nodes.length) return;

    if (!motionOn || reducedMotion() || !('IntersectionObserver' in window)) {
      revealAll(nodes);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('riva-hiw-visible');
          io.unobserve(entry.target);
        });
      },
      { root: null, rootMargin: '0px 0px -8% 0px', threshold: [0, 0.06, 0.12] }
    );

    nodes.forEach(function (node) {
      node.classList.add('riva-hiw-prepped');
      io.observe(node);
    });
  }

  function boot() {
    document.querySelectorAll('[data-riva-how-it-works]').forEach(initHowItWorks);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var el = ev.target;
    if (!el || !el.querySelector) return;
    var sec = el.querySelector('[data-riva-how-it-works]');
    if (sec) {
      sec.dataset.rivaHiwInit = '';
      sec.querySelectorAll('[data-riva-hiw-animate]').forEach(function (n) {
        n.classList.remove('riva-hiw-prepped', 'riva-hiw-visible');
      });
      initHowItWorks(sec);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["riva-image-headline"] && !Shopify.designMode) return;
  try {
    
(function () {
  var BASE_SCALE = 1.05;
  var PARALLAX_RANGE = 2.2;

  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initScrollReveal(root) {
    if (root.dataset.rivaIhRevealInit === '1') return;
    if (root.dataset.ihReveal !== '1') return;
    root.dataset.rivaIhRevealInit = '1';
    if (reducedMotion()) {
      root.classList.add('riva-image-headline--inview');
      return;
    }
    root.classList.add('riva-image-headline--reveal-ready');
    if (!('IntersectionObserver' in window)) {
      root.classList.add('riva-image-headline--inview');
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          root.classList.add('riva-image-headline--inview');
          io.unobserve(root);
        });
      },
      { root: null, rootMargin: '0px 0px -4% 0px', threshold: [0, 0.05, 0.1, 0.2] }
    );
    io.observe(root);
  }

  function initParallax(root) {
    if (root.dataset.rivaIhParallaxInit === '1') return;
    if (root.dataset.ihParallax !== '1') return;

    var img = root.querySelector('.riva-image-headline__bg-img');
    if (!img) return;
    if (reducedMotion()) {
      root.dataset.rivaIhParallaxInit = '1';
      return;
    }

    root.dataset.rivaIhParallaxInit = '1';
    var frame = null;

    function tick() {
      frame = null;
      var rect = root.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      var track = vh + rect.height;
      var progress = (vh - rect.top) / track;
      progress = Math.max(0, Math.min(1, progress));
      var centered = (progress - 0.5) * 2;
      var maxShift = Math.min(160, Math.max(60, rect.height * 0.28));
      var y = centered * maxShift * PARALLAX_RANGE * -0.48;
      img.style.transform = 'translate3d(0,' + y.toFixed(2) + 'px,0) scale(' + BASE_SCALE + ')';
    }

    function onScrollOrResize() {
      if (frame != null) return;
      frame = window.requestAnimationFrame(tick);
    }

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
    tick();
  }

  function initBlock(root) {
    if (!root || root.dataset.rivaIhBlockInit === '1') return;
    root.dataset.rivaIhBlockInit = '1';
    initScrollReveal(root);
    initParallax(root);
  }

  function boot() {
    document.querySelectorAll('[data-riva-image-headline]').forEach(initBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var el = ev.target;
    if (!el || !el.querySelector) return;
    var inner = el.querySelector('[data-riva-image-headline]');
    if (inner) {
      inner.dataset.rivaIhBlockInit = '';
      inner.dataset.rivaIhRevealInit = '';
      inner.dataset.rivaIhParallaxInit = '';
      inner.classList.remove('riva-image-headline--reveal-ready', 'riva-image-headline--inview');
      initBlock(inner);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["riva-image-text"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initImageText(root) {
    if (!root || root.dataset.rivaItInit === '1') return;
    root.dataset.rivaItInit = '1';

    var motionOn = root.dataset.rivaItMotion === '1';

    if (!motionOn || reducedMotion() || !('IntersectionObserver' in window)) {
      root.classList.remove('riva-image-text--reveal-prepped');
      root.classList.add('riva-image-text--inview');
      return;
    }

    root.classList.add('riva-image-text--reveal-prepped');

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          root.classList.add('riva-image-text--inview');
          io.unobserve(root);
        });
      },
      { root: null, rootMargin: '0px 0px -8% 0px', threshold: [0, 0.08, 0.15] }
    );

    io.observe(root);
  }

  function bootAll() {
    document.querySelectorAll('[data-riva-image-text]').forEach(initImageText);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var wrap = ev.target;
    if (!wrap || !wrap.id || wrap.id.indexOf('shopify-section-') !== 0) return;
    var root = wrap.querySelector('[data-riva-image-text]');
    if (!root) return;
    root.dataset.rivaItInit = '';
    root.classList.remove('riva-image-text--reveal-prepped', 'riva-image-text--inview');
    initImageText(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["riva-mission-statement"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initMissionStatement(root) {
    if (!root || root.dataset.rivaMsInit === '1') return;
    root.dataset.rivaMsInit = '1';

    var motionOn = root.dataset.rivaMsMotion === '1';

    if (!motionOn || reducedMotion() || !('IntersectionObserver' in window)) {
      root.classList.remove('riva-mission-statement--reveal-prepped');
      root.classList.add('riva-mission-statement--inview');
      return;
    }

    root.classList.add('riva-mission-statement--reveal-prepped');

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          root.classList.add('riva-mission-statement--inview');
          io.unobserve(root);
        });
      },
      { root: null, rootMargin: '0px 0px -8% 0px', threshold: [0, 0.08, 0.15] }
    );

    io.observe(root);
  }

  function bootAll() {
    document.querySelectorAll('[data-riva-mission-statement]').forEach(initMissionStatement);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var wrap = ev.target;
    if (!wrap || !wrap.id || wrap.id.indexOf('shopify-section-') !== 0) return;
    var root = wrap.querySelector('[data-riva-mission-statement]');
    if (!root) return;
    root.dataset.rivaMsInit = '';
    root.classList.remove('riva-mission-statement--reveal-prepped', 'riva-mission-statement--inview');
    initMissionStatement(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["riva-page-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initPageHero(hero) {
    if (!hero || hero.dataset.rivaPhInit === '1') return;
    hero.dataset.rivaPhInit = '1';

    var motionOn = hero.dataset.rivaPhMotion === '1';

    if (!motionOn || reducedMotion() || !('IntersectionObserver' in window)) {
      hero.classList.remove('riva-page-hero--reveal-prepped');
      hero.classList.add('riva-page-hero--inview');
      return;
    }

    hero.classList.add('riva-page-hero--reveal-prepped');

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          hero.classList.add('riva-page-hero--inview');
          io.unobserve(hero);
        });
      },
      { root: null, rootMargin: '0px 0px -6% 0px', threshold: [0, 0.08, 0.15] }
    );

    io.observe(hero);
  }

  function bootAll() {
    document.querySelectorAll('[data-riva-page-hero]').forEach(initPageHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var wrap = ev.target;
    if (!wrap || !wrap.id || wrap.id.indexOf('shopify-section-') !== 0) return;
    var hero = wrap.querySelector('[data-riva-page-hero]');
    if (!hero) return;
    hero.dataset.rivaPhInit = '';
    hero.classList.remove('riva-page-hero--reveal-prepped', 'riva-page-hero--inview');
    initPageHero(hero);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["riva-treatment-categories"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function revealAll(nodes) {
    nodes.forEach(function (n) {
      n.classList.remove('riva-tc-prepped');
      n.classList.add('riva-tc-visible');
    });
  }

  function initTreatmentCategories(sectionEl) {
    if (!sectionEl || sectionEl.dataset.rivaTcInit === '1') return;
    sectionEl.dataset.rivaTcInit = '1';

    var motionOn = sectionEl.dataset.rivaTcMotion === '1';
    var nodes = sectionEl.querySelectorAll('[data-riva-tc-animate]');
    if (!nodes.length) return;

    if (!motionOn || reducedMotion() || !('IntersectionObserver' in window)) {
      revealAll(nodes);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var t = entry.target;
          t.classList.add('riva-tc-visible');
          io.unobserve(t);
        });
      },
      { root: null, rootMargin: '0px 0px -8% 0px', threshold: [0, 0.06, 0.12] }
    );

    nodes.forEach(function (node) {
      node.classList.add('riva-tc-prepped');
      io.observe(node);
    });
  }

  function boot() {
    document.querySelectorAll('[data-riva-treatment-categories]').forEach(initTreatmentCategories);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var el = ev.target;
    if (!el || !el.querySelector) return;
    var sec = el.querySelector('[data-riva-treatment-categories]');
    if (sec) {
      sec.dataset.rivaTcInit = '';
      sec.querySelectorAll('[data-riva-tc-animate]').forEach(function (n) {
        n.classList.remove('riva-tc-prepped', 'riva-tc-visible');
      });
      initTreatmentCategories(sec);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["riva-treatments-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function sectionWrap(el) {
    return el && el.closest('[id^="shopify-section-"]');
  }

  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function revealAll(wrap, nodes) {
    nodes.forEach(function (n) {
      n.classList.remove('riva-tcar-prepped');
      n.classList.add('riva-tcar-visible');
    });
  }

  function initScrollAnim(wrap) {
    if (!wrap || wrap.dataset.rivaTcarAnimInit === '1') return;
    var inner = wrap.querySelector('[data-riva-treatments-carousel]');
    if (!inner) return;

    var motionOn = inner.dataset.rivaTcarMotion === '1';
    var nodes = wrap.querySelectorAll('[data-riva-tcar-animate]');
    if (!nodes.length) return;

    wrap.dataset.rivaTcarAnimInit = '1';

    if (!motionOn || reducedMotion() || !('IntersectionObserver' in window)) {
      revealAll(wrap, nodes);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('riva-tcar-visible');
          io.unobserve(entry.target);
        });
      },
      { root: null, rootMargin: '0px 0px -8% 0px', threshold: [0, 0.06, 0.12] }
    );

    nodes.forEach(function (node) {
      node.classList.add('riva-tcar-prepped');
      io.observe(node);
    });
  }

  function initNav(wrap) {
    if (!wrap || wrap.dataset.rivaTcarNavInit === '1') return;
    var section = wrap.querySelector('[data-riva-treatments-carousel]');
    if (!section) return;
    var track = section.querySelector('.riva-treatments-carousel__track');
    var prevBtn = section.querySelector('.riva-treatments-carousel__nav-btn--prev');
    var nextBtn = section.querySelector('.riva-treatments-carousel__nav-btn--next');
    if (!track || !prevBtn || !nextBtn) return;

    wrap.dataset.rivaTcarNavInit = '1';

    function getScrollAmount() {
      var card = track.querySelector('.riva-treatment-product-card');
      if (!card) return 280;
      var gapRaw = getComputedStyle(track).gap || '20px';
      var gap = parseInt(gapRaw, 10);
      if (isNaN(gap)) gap = 20;
      return card.offsetWidth + gap;
    }

    function onNext() {
      track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    }
    function onPrev() {
      track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    }

    nextBtn.addEventListener('click', onNext);
    prevBtn.addEventListener('click', onPrev);
  }

  function boot(wrap) {
    if (!wrap) return;
    initScrollAnim(wrap);
    initNav(wrap);
  }

  function bootAll() {
    document.querySelectorAll('[data-riva-treatments-carousel]').forEach(function (inner) {
      boot(sectionWrap(inner));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var wrap = ev.target;
    if (!wrap || !wrap.id || wrap.id.indexOf('shopify-section-') !== 0) return;
    if (!wrap.querySelector('[data-riva-treatments-carousel]')) return;
    wrap.dataset.rivaTcarNavInit = '';
    wrap.dataset.rivaTcarAnimInit = '';
    wrap.querySelectorAll('[data-riva-tcar-animate]').forEach(function (n) {
      n.classList.remove('riva-tcar-prepped', 'riva-tcar-visible');
    });
    boot(wrap);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
